<template>
  <div class="ab_players_cont">
    <div class="ab_players text-nowrap">
      <div
        v-for="(player, idx) in players"
        :key="player.position + idx"
        class="ab_player"
        :style="
          player.is_hero
            ? 'color: var(--clr-hero)'
            : opponent === player.position
              ? 'color: var(--clr-opponent)'
              : 'color: var(--clr-grey-2)'
        "
      >
        <div
          class="ab_player_position ab_player_cell"
          v-html="getPlayerHtmlPosition(player.position)"
        ></div>

        <div class="ab_player_stack ab_player_cell">{{ numFixedUnit(player.stack, 'bb') }} BB</div>
        <div
          v-if="player.name"
          class="ab_player_name ab_player_cell"
        >
          <div class="ab_player_name_content">
            <div
              class="ab_player_name_text"
              :title="player.name"
            >
              {{ player.name }}
            </div>

            <div
              v-if="player.hasColorNoteEdit"
              class="f-center ab_player_settings"
              style="gap: 0.25rem"
            >
              <div
                v-if="player.color_hex || player.note"
                class="gw_btn gw_btn_text gw_btn_small clr-grey csst"
                style="padding: 0.125rem; height: 1.25rem"
                @click="
                  () => $emit('update:player', { player: { ...player, color_hex: '', note: '' } })
                "
              >
                <div class="mdi mdi-close"></div>
                <div
                  class="csst_content clr-white"
                  style="transform: translateX(-100%); left: 100%; top: -1.5rem"
                >
                  {{ $t('tooltips.remove_player_color') }}
                </div>
              </div>
              <HaPlayerClrMenu
                :player="player"
                @update:player="({ player }) => $emit('update:player', { player })"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HaPlayerClrMenu from '@/components/AnalyzeStreetBlocks/HaPlayerClrMenu'
import format_mix from '@/mixins/format_mix'
import float_mix from '@/mixins/float_mix'

export default {
  name: 'HaPlayers',
  components: {
    HaPlayerClrMenu,
  },
  mixins: [format_mix, float_mix],
  props: {
    hero: String,
    opponent: String,
    players: Array,
    hasDevStats: Boolean,
  },
  emits: ['update:player'],
  data() {
    return {
      l_player: null,
    }
  },
  methods: {
    updatePlayer(player) {
      this.$emit('update:player', { player: this.l_player || player })
    },
    updateLocalPlayer({ player, color_hex, note }) {
      this.l_player = { ...player }
      this.l_player.color_hex = color_hex || this.l_player.color_hex
      this.l_player.note = note || this.l_player.note
      // console.log(this.l_player)
    },
  },
}
</script>

<style lang="scss" scoped>
.ab {
  &_players {
    display: table;
    max-width: 100%;
  }
  &_player {
    --settings-color-opacity: 1;
    --clr-back: transparent;
    display: table-row;
    position: relative;
    height: 1.5rem;
    &_cell {
      display: table-cell;
      position: relative;
      z-index: 1;
      font-size: var(--ha-position-size);
      height: 100%;
    }
    &_position {
      font-size: var(--ha-position-size);
      font-weight: var(--ha-position-weight);
      width: var(--ha-position-width);
      min-width: var(--ha-position-width);
    }
    &_stack {
      padding: 0;
      font-weight: 500;
      height: 1.5rem;
    }
    &_name {
      width: 100%;
      height: 100%;
      font-weight: 500;
      font-size: 0.875rem;
      padding: 0 0 0 1rem;
      position: relative;
      &_content {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        top: 0;
      }
      &_text {
        overflow: hidden;
        max-width: 8.875rem;
        text-overflow: ellipsis;
        white-space: nowrap;
        margin-right: auto;
      }
    }
    &_settings {
      position: absolute;
      right: 1.125rem;
      opacity: var(--settings-color-opacity);
    }
  }
}
</style>
